/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Calm_Wolf_RestInputs */

const en_deep_calm_wolf_rest = /** @type {(inputs: Deep_Calm_Wolf_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentiality`)
};

const de_deep_calm_wolf_rest = /** @type {(inputs: Deep_Calm_Wolf_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertraulichkeit`)
};

/**
* | output |
* | --- |
* | "Confidentiality" |
*
* @param {Deep_Calm_Wolf_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_calm_wolf_rest = /** @type {((inputs?: Deep_Calm_Wolf_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Calm_Wolf_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_calm_wolf_rest(inputs)
	return de_deep_calm_wolf_rest(inputs)
});